<template>
    <div class="left-label-warp" v-loading="loading">
        <div class="pt10 pb10 pl10 pr10 flex-box al-c">
            <el-input
                    v-model="keywords"
                    placeholder="请输入标签名称"
                    size="mini"
                    style="width: 210px"
                    clearable
                    @change="getLabelListFn"
            ></el-input>
            <el-button size="mini" type="primary" style="margin-left: auto" @click="handleAdd">+添加</el-button>
        </div>
        <div class="my-label-title">我的标签</div>
        <ul  v-if="labelList.length&&!loading">
            <li v-for="(item,index) in labelList"
                class="cl-f"
                :class="{'selected':item.labelId==curItem}"
               >
                <div class="left"  @click="switchItemFn(item)">
                    <div class="label_icon">
                        <img  v-if="item.labelType=='0'" :src="`${baseUrl}images/static_label_icon.png`" />
                        <img  v-if="item.labelType=='1'" :src="`${baseUrl}images/dynamic_label_icon.png`" />
                    </div>

                    <div class="label_name" v-text="item.labelName"></div>
                </div>
                <div class="right">
                    <el-dropdown @command="handleCommand($event,item)">
                          <span class="el-dropdown-link">
                             <i class="el-icon-more"></i>
                          </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item  command="editLabel">详情</el-dropdown-item>
                            <el-dropdown-item  command="del">删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                </div>
            </li>
        </ul>
        <div v-if="labelList.length==0&&!loading" class="no-data">未查询到岗位</div>
    </div>
</template>

<script>
    import { getAllLabelList,handleDelLabel} from '@/api/managementCenter/labelManage';
    export default {
        name: "leftLabelList",
        data(){
            return{
                baseUrl: process.env.BASE_URL,
                loading:false,
                keywords:'',
                curItem:'',
                list:[]
            }
        },
        mounted(){
            this.getLabelListFn();
        },
        computed:{
            labelList(){
                let arr;
                if(this.keywords){
                    arr=this.list.filter(item=>{
                        return item.labelName.indexOf(this.keywords)>-1;
                    });
                }else{
                    arr=this.list;
                }
                return arr;
            }
        },
        methods:{
            handleAdd(){
                this.$emit('leftLabelClick','addLabel',null)
            },
            getLabelListFn(){
                this.loading=true;
                getAllLabelList().then(({data}) => {
                    this.loading=false;
                        if(data.code == 0){
                            this.list=data.data||[];
                            this.keywords="";
                            if(this.list.length){
                                this.switchItemFn(this.list[0]);
                            }else{
                                this.switchItemFn({});
                            }
                        }else{
                            this.$message.warning( data.msg||"获取标签失败！" );
                        }
                    }).catch(err=>{
                    this.loading=false;
                    })
            },
            switchItemFn(item){
                this.curItem=item.labelId;
                this.$emit('leftLabelClick','memberList',item)
            },
            handleCommand(type,item){
                if(type=='del'){
                    this.handleDelFn(item.labelId)
                }else{
                    this.curItem=item.labelId;
                    this.$emit('leftLabelClick',type,item)
                }
            },
            // 删除
            handleDelFn(id){
                this.$confirm( "是否确定删除?", "提示", {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteHttp(id)

                }).catch(() => {
                    this.$message.info( "已取消删除" );

                });
            },
            deleteHttp(id){
                this.loading = true;
                // 删除接口
                handleDelLabel(id).then( ({data}) => {
                    this.loading = false;
                    if(data.code == 0){
                        this.$message.success("删除成功!" );
                        this.getLabelListFn();
                    }else{
                        this.$message.warning( data.msg||"删除失败！" );
                    }
                }).catch(() => {
                    this.loading = false;
                    this.$message.error( "删除异常!" );
                });
            },
        }
    }
</script>

<style scoped lang="less">
.left-label-warp{
    >.my-label-title{
        background: #F3F3F3;
        color: #ccc;
        padding-left: 10px;
        height: 30px;
        line-height: 30px;
        font-weight: bold;

    }
    >ul{
        padding-top: 10px;
        height: calc(100vh - 220px);
        overflow-y: auto;
        >li{
            color: #666;
            padding:0 10px;
            line-height: 40px;
            font-weight: bold;
            font-size: 13px;
            border-bottom: 1px dashed #F1F3F4;
            cursor: pointer;
            width: 100%;
            box-sizing: border-box;
            &:hover{
                background: rgba(241, 243, 244,0.5);
                color: #000000;
                font-size: 14px;
            }
            &.selected{
                background: #F3F3F3;
                color: #666666;
                font-size: 13px;
                border-bottom: 1px solid #FFFFFF;
                  i{
                      color: #666666!important;
                  }

              }
            .left{
                float: left;
                width: calc(100% - 20px);
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
                .label_icon{
                    float: left;
                    width: 15px;
                    margin-right: 5px;
                    img{
                        vertical-align: top;
                        width: 100%;
                        padding-top: 9px;
                    }

                }
                .label_name{
                    float: left;
                    width: calc(100% - 30px);
                }

            }
            .right{
                width:18px;
                float: right;
                text-align: right;
                .el-dropdown{
                    position: relative;
                    top: -16px;
                }
                i{
                    transform:rotate(90deg);
                    -ms-transform:rotate(90deg);
                    -moz-transform:rotate(90deg);
                    -webkit-transform:rotate(90deg);
                    -o-transform:rotate(90deg);
                    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
                    position: relative;
                    top: 16px;
                    color: #ccc;
                    &:hover{
                        color: #666666;
                    }
                }
            }
        }
    }

}
</style>
